<template>
    <div class="auction container">
        <lot-filter></lot-filter>
        <lot-cards></lot-cards>
    </div>
</template>

<script>
    import LotCards from "./modules/lotCards";
    import LotFilter from "./modules/lotFilter";
    import {store} from "../../store/lot";

    export default {
        name: "Auction",
        store,
        components: {LotFilter, LotCards},
    }
</script>